document.addEventListener("click", function() {
    document.body.style.zoom = "100%";
});
document.addEventListener("gesturestart", function(e) {
    e.preventDefault();
    document.body.style.zoom = 0.99;
});
document.addEventListener("gesturechange", function(e) {
    e.preventDefault();
    document.body.style.zoom = 0.99;
});
document.addEventListener("gestureend", function(e) {
    e.preventDefault();
    document.body.style.zoom = 1;
});

//# sourceMappingURL=index.dd581d4a.js.map
